import { FunctionComponent } from "react";

import { useFieldContext, useFieldRegister } from "@bps/fluent-ui";

import { UsersSelect, UsersSelectProps } from "../../selects/UsersSelect.tsx";

export interface UsersSelectFilterItemProps
  extends Omit<
    UsersSelectProps,
    "selectedKeys" | "onChangeSelectedKeys" | "onFocus" | "onBlur"
  > {
  name: string;
}
export const UsersSelectFilterItem: FunctionComponent<
  UsersSelectFilterItemProps
> = ({ name, ...usersSelectProps }) => {
  useFieldRegister(name);

  const { value, setFieldValue, focusField, blurField } = useFieldContext<
    string | undefined | string[]
  >(name);

  return (
    <UsersSelect
      {...usersSelectProps}
      onFocus={focusField}
      onBlur={blurField}
      selectedKeys={value as any}
      onChangeSelectedKeys={setFieldValue}
    />
  );
};
